module.exports = __webpack_public_path__ + "img/grade-rep.70529f4c.png";